/*
// Licensed Materials - Property of HCL
// (C) Copyright HCL Technologies Limited 2001, 2020
// All Rights Reserved
*/

export const MESSAGE_SUCCESS = 'MESSAGE_SUCCESS'
export const MESSAGE_WARNING = 'MESSAGE_WARNING'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
